import { render, staticRenderFns } from "./WastenotificationsForm.vue?vue&type=template&id=653b1a23"
import script from "./WastenotificationsForm.vue?vue&type=script&lang=js"
export * from "./WastenotificationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports